import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ResidentialServicesPage = lazy(() => import('../pages/residential-services/page'));
const IndustrialServicesPage = lazy(() => import('../pages/industrial-services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/commercial-services',
    element: <ServicesPage />,
  },
  {
    path: '/residential-services',
    element: <ResidentialServicesPage />,
  },
  {
    path: '/industrial-services',
    element: <IndustrialServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;